export const isJestOrStorybook = () => {
  return process.env.JEST_WORKER_ID !== undefined || process.env.STORYBOOK_MODE !== undefined;
};

export const isJest = () => {
  return process.env.JEST_WORKER_ID !== undefined;
};
